import { getScreenshots, deleteScreenshot } from '../../api/tablets';

export const CHANGE_TABLET_SCREENSHOTS_VALUE = 'CHANGE_TABLET_SCREENSHOTS_VALUE';
export const CHANGE_TABLET_SCREENSHOTS_SEVERAL_VALUES = 'CHANGE_TABLET_SCREENSHOTS_SEVERAL_VALUES';

export const RESET_TABLET_SCREENSHOTS_STORE = 'RESET_TABLET_SCREENSHOTS_STORE';

export const GET_TABLET_SCREENSHOTS = 'GET_TABLET_SCREENSHOTS';
export const GET_TABLET_SCREENSHOTS_SUCCESS = 'GET_TABLET_SCREENSHOTS_SUCCESS';
export const GET_TABLET_SCREENSHOTS_ERROR = 'GET_TABLET_SCREENSHOTS_ERROR';

export const DELETE_TABLET_SCREENSHOT = 'DELETE_TABLET_SCREENSHOT';
export const DELETE_TABLET_SCREENSHOT_SUCCESS = 'DELETE_TABLET_SCREENSHOT_SUCCESS';
export const DELETE_TABLET_SCREENSHOT_ERROR = 'DELETE_TABLET_SCREENSHOT_ERROR';

export const getTabletScreenshotsAction = (uuid, params) => {
  return async (dispatch) => {
    dispatch({ type: GET_TABLET_SCREENSHOTS, payload: params.cursorDirection === 'FIRST' });
    try {
      const response = await getScreenshots(uuid, params);
      const { success, results } = response;
      if (success) {
        dispatch({ type: GET_TABLET_SCREENSHOTS_SUCCESS, payload: results, params });
      }
    } catch (error) {
      dispatch({ type: GET_TABLET_SCREENSHOTS_ERROR });
    }
  };
};

export const deleteTabletScreenshotAction = (tabletUuid, uuid, actions) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_TABLET_SCREENSHOT });
    try {
      const response = await deleteScreenshot(tabletUuid, uuid);
      const { success } = response;
      if (success) {
        actions.onSuccess();
        dispatch({ type: DELETE_TABLET_SCREENSHOT_SUCCESS });
      }
    } catch (error) {
      actions.onError(error.message);
      dispatch({ type: DELETE_TABLET_SCREENSHOT_ERROR });
    }
  };
};

export const changeValue = (key, value) => ({
  type: CHANGE_TABLET_SCREENSHOTS_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_TABLET_SCREENSHOTS_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_TABLET_SCREENSHOTS_STORE,
});
